import { useTranslation } from 'react-i18next';
import { CHAT_EMOJIS, CHAT_PRESETS, PRESET_PREFIX } from '@draughts/shared';
import './ChatPresetPalette.css';

interface ChatPresetPaletteProps {
  /** Send a wire message: a raw emoji, or a `preset:<key>` token. */
  onSend: (wireMessage: string) => void;
  disabled?: boolean;
  /** Serve al bottone che la apre per puntarla con `aria-controls`. */
  id?: string;
}

/**
 * Le frasi pronte e le emoji, una tavolozza sola per due usi: l'ospite ce l'ha
 * sempre a vista (è l'unico modo che ha di parlare), l'iscritto la trova nel
 * cassetto accanto alla casella di testo. Le frasi viaggiano come chiave, così
 * ognuno le legge nella propria lingua; le emoji come carattere.
 */
function ChatPresetPalette({ onSend, disabled = false, id }: ChatPresetPaletteProps) {
  const { t } = useTranslation();

  return (
    <div className="chat-palette" id={id}>
      <div className="chat-palette-phrases">
        {CHAT_PRESETS.map((preset) => (
          <button
            key={preset.key}
            type="button"
            className="chat-palette-phrase"
            onClick={() => onSend(`${PRESET_PREFIX}${preset.key}`)}
            disabled={disabled}
          >
            {t(`chat.presets.${preset.key}`)}
          </button>
        ))}
      </div>

      <div className="chat-palette-emojis">
        {CHAT_EMOJIS.map((emoji) => (
          <button
            key={emoji}
            type="button"
            className="chat-palette-emoji"
            onClick={() => onSend(emoji)}
            disabled={disabled}
            aria-label={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ChatPresetPalette;
